import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
	loaded: number;
	total: number;
	loading: boolean;
	onLoadMore: () => void;
}

export function LoadMoreTasks({ loaded, total, loading, onLoadMore }: Props) {
	return (
		<div className="flex flex-col items-center gap-2 mt-6">
			<p className="text-xs text-muted">
				Showing {loaded} of {total} tasks
			</p>
			<Button
				variant="outline"
				size="sm"
				onClick={onLoadMore}
				disabled={loading}
			>
				{loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
				Load more
			</Button>
		</div>
	);
}
